export default __webpack_public_path__ + "components/weather-icon/static/dayheavysnow-6c720437b1e46cc9e080e6bb07a18e76.webp";